export default "__VITE_ASSET__TN5ASv1K__"